module.exports = __webpack_public_path__ + "static/img/video_img.03be058d.png";